import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { getCountdown } from 'JS/utilities/simple-countdown';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCountdownTimer',
  props: {
    endDate: null
  },
  setup(__props: any) {

const props = __props as {
	endDate: string
}



const lastTickTimeMS = ref(Date.now());

function startTimer(): number {
	const timer = window.setInterval(() => {
		const done = tick();
		if (done) {
			clearInterval(timer);
		}
	}, 1000);

	return timer;
}

function tick(): boolean {
	lastTickTimeMS.value = Date.now();
	return countdown.value.done;
};

const endDate = computed(() => Date.parse(props.endDate));
const countdown = computed(() => getCountdown({
	from: lastTickTimeMS.value,
	to: endDate.value,
}));

watch(() => props.endDate, (_endDate, _, onCleanup) => {
	const done = tick();
	if (done || typeof window === 'undefined') {
		return;
	}

	const timer = startTimer();
	onCleanup(() => window.clearInterval(timer));
}, { immediate: true });


return { __sfc: true,props, lastTickTimeMS, startTimer, tick, endDate, countdown }
}

})